import { CRS } from "./CRS";
import cursor_yoy from "url:../../../assets/cursors/YoYoCursor.png";

export function YOY () {
    return <CRS>
        <img src={cursor_yoy} className='mcs-icon' />
    </CRS>
}